import React, { PropsWithChildren } from 'react';
import { State } from './types/state';

export interface SERPStateProviderProps {
    state: State;
}

const SERPStateContext = React.createContext<State | undefined>(undefined);

export const SERPStateProvider: React.FC<PropsWithChildren<SERPStateProviderProps>> = ({ children, state }) => (
    <SERPStateContext.Provider value={state}>{children}</SERPStateContext.Provider>
);

export const useSERPState = () => {
    const context = React.useContext(SERPStateContext);
    if (context === undefined) {
        throw new Error('useSearchState must be used within a SearchStateProvider');
    }
    return context;
};
